import { render, staticRenderFns } from "./BookAppearanceTextAlign.vue?vue&type=template&id=0558fe18"
import script from "./BookAppearanceTextAlign.vue?vue&type=script&lang=js"
export * from "./BookAppearanceTextAlign.vue?vue&type=script&lang=js"
import style0 from "./BookAppearanceTextAlign.vue?vue&type=style&index=0&id=0558fe18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports